<template>
  <div v-if="isVisible" class="bottom-banner">
    <div class="banner-content">
      <!-- 横幅主体内容，点击唤起 53客服 -->
      <a href="javascript:;" class="banner-link kf-consult-btn" @pointerdown="preloadCustomerService" @click="openCustomerService" data-buriedname="bottomBanner_kf" data-buriedvalue="bottomBanner_kf">
        <img :src="bannerBgPath" alt="活动横幅" class="banner-img" />
      </a>
      
      <!-- 右上角关闭按钮 -->
      <button class="close-btn" @click.stop="closeBanner" aria-label="关闭">
        <img :src="closeIconPath" alt="关闭" />
      </button>
    </div>
  </div>
</template>

<script setup>

import { openCustomerService, preloadCustomerService } from '@/utils/CustomerService'
import { ref, computed } from 'vue'
import { useSiteConfigStore } from '@/stores/SiteConfig'
import { getImagePrefix } from '@/utils/ImageHelper'

const siteConfig = useSiteConfigStore()

// 统一获取当前语言的辅助函数
const currentLang = computed(() => {
  try {
    if (siteConfig?.profile) return siteConfig.profile
    if (typeof __SITE_PROFILE__ !== 'undefined') return __SITE_PROFILE__ || 'de'
    if (typeof window !== 'undefined' && window.__INITIAL_SITE_CONFIG__?.profile) return window.__INITIAL_SITE_CONFIG__.profile
  } catch (e) {
    // 忽略异常
  }
  return 'de'
})

// === 处理横幅的可见性和错误 ===

// 配置哪些语言站有底层横幅（这能彻底避免未配置的国家发送多余的图片请求报 404）
const supportedLangs = ['de', 'fr', 'ru', 'es']

// 活动时间：2026.09.01 - 2026.09.30（含首尾两天）
const activityStartTime = new Date('2026-09-01T00:00:00').getTime()
const activityEndTime = new Date('2026-10-01T00:00:00').getTime()
const now = Date.now()
const isInActivityPeriod = now >= activityStartTime && now < activityEndTime

// 记录用户是否已经在当前会话中手动关闭过弹窗（避免页面跳转或刷新后再次弹出）
const isClosedInSession = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('bottomBannerClosed') === 'true' : false

// 支持的语言站 + 活动期内 + 当前会话未手动关闭，才显示横幅
const isVisible = ref(
  supportedLangs.includes(currentLang.value) && isInActivityPeriod && !isClosedInSession
)

const closeBanner = () => {
  isVisible.value = false
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem('bottomBannerClosed', 'true')
  }
}

// 按站点拼接图片路径，CDN 前缀由 siteConfig.cdnPrefix 处理
const bannerBgPath = computed(() => {
  const lang = currentLang.value
  const bottomBannerPath = `/img/v2/common/footer/autumn2026/${lang}.png`
  const cdnPrefix = siteConfig?.cdnPrefix || (typeof __CDN_PREFIX__ !== 'undefined' ? __CDN_PREFIX__ : '')
  return cdnPrefix ? `${cdnPrefix}${bottomBannerPath}` : bottomBannerPath
})

// 获取关闭图标的路径
const closeIconPath = computed(() => {
  const prefix = getImagePrefix()
  return `${prefix}/${currentLang.value}/evevt/close.svg`
})
</script>

<style scoped lang="scss">
.bottom-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 998; /* 稍微低于右侧边栏，但高于大部分页面内容 */
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  pointer-events: none; /* 让外层容器不阻挡鼠标事件，只在内容区域阻挡 */
}

.banner-content {
  position: relative;
  display: inline-block;
  pointer-events: auto; /* 恢复子元素的鼠标交互 */
  width: 100%; /* 横满全屏 */
}

.banner-link {
  display: block;
  width: 100%;
}

.banner-img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.close-btn {
  position: absolute;
  /* 按 3840px 宽度换算 vw：
     宽高：36px / 3840 * 100 = 0.9375vw
     右边距：5px / 3840 * 100 = 0.13vw
     上边距：按钮看起来距离顶部大约是整个 240 高度的一半偏上，或固定像素比如 43px 换算 43/3840 = 1.11vw */
  width: 0.9375vw;
  height: 0.9375vw;
  top: 2.61vw; /* 这个如果您觉得太高/太低，可以微调，比如改成 1vw 或 1.5vw */
  right: 0.63vw; 
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  
  img {
    width: 100%;
    height: 100%; /* 让图片撑满按钮的vw级别空间 */
    opacity: 0.8;
    transition: opacity 0.2s;
  }

  &:hover img {
    opacity: 1;
  }
}


</style>
